export const PAYMENT_REMINDERS = [
  'PayPal: We will direct you to the PayPal payment page to pay the Advertisement after pressed “Submit Payment Request” button.',
  'You could also pay with your credit card without PayPal account. Press “Pay with a card” on PayPal login page',
  'Bank Wire: We will send you an invoice with our bank info to process the payment after pressed “Submit Payment Request” button',
];
